import {
  MOTIVOCANCELACION_ERROR,
  MOTIVOCANCELACION_LOADING,
  MOTIVOCANCELACION_SUCCESS,
  MOTIVOCANCELACIONLABORATORIO_SUCCESS,
  MOTIVOCANCELACION_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

/* export const wsGetMotivoCancelacion = () => (dispatch) => {
  dispatch({
    type: MOTIVOCANCELACION_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/turnos/motivosCancelacion`)
      .then((res) => {
        dispatch({
          type: MOTIVOCANCELACION_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: MOTIVOCANCELACION_ERROR,
          payload: error,
        });
      });
  });
}; */
export const wsGetMotivoCancelacion = () => (dispatch) => {
  dispatch({
    type: MOTIVOCANCELACION_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`his/turnos/motivosCancelacion`)
      .then((res) => {
        dispatch({
          type: MOTIVOCANCELACION_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: MOTIVOCANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

/* export const wsGetMotivoCancelacionLaboratorio = () => (dispatch) => {
  dispatch({
    type: MOTIVOCANCELACION_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/laboratorio/motivoCancelaciones`)
      .then((res) => {
        dispatch({
          type: MOTIVOCANCELACIONLABORATORIO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: MOTIVOCANCELACION_ERROR,
          payload: error,
        });
      });
  });
}; */
export const wsGetMotivoCancelacionLaboratorio = () => (dispatch) => {
  dispatch({
    type: MOTIVOCANCELACION_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/motivoCancelaciones`)
      .then((res) => {
        dispatch({
          type: MOTIVOCANCELACIONLABORATORIO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: MOTIVOCANCELACION_ERROR,
          payload: error,
        });
      });
  });
};

export const motivoCancelacionReset = () => (dispatch) => {
  dispatch({
    type: MOTIVOCANCELACION_RESET,
  });
};
